import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-final-form';
import { ArrowRight } from '@tpr/icons';
import { P, Button, Flex } from '@tpr/core';
import { FFSelect } from '../select/select';
import { formatPostcode } from './services';
import styles from './addressLookup.module.scss';
import elementStyles from '../elements.module.scss';
export var SelectAddress = function (_a) {
    var loading = _a.loading, testId = _a.testId, postcode = _a.postcode, addresses = _a.addresses, onChangePostcodeClick = _a.onChangePostcodeClick, onAddressSelected = _a.onAddressSelected, postcodeLookupLabel = _a.postcodeLookupLabel, changePostcodeButton = _a.changePostcodeButton, changePostcodeAriaLabel = _a.changePostcodeAriaLabel, selectAddressLabel = _a.selectAddressLabel, selectAddressPlaceholder = _a.selectAddressPlaceholder, selectAddressButton = _a.selectAddressButton, selectAddressRequiredMessage = _a.selectAddressRequiredMessage, noAddressesFoundMessage = _a.noAddressesFoundMessage, onValidatePostcode = _a.onValidatePostcode;
    var ensureNoUndefinedFields = function (addresses) {
        return addresses && addresses.length
            ? addresses.map(function (address) {
                return {
                    addressLine1: address.addressLine1 || '',
                    addressLine2: address.addressLine2 || '',
                    addressLine3: address.addressLine3 || '',
                    postTown: address.postTown || '',
                    county: address.county || '',
                    postcode: address.postcode || '',
                    nationId: address.nationId || null,
                    country: address.country || '',
                    countryId: address.countryId || null,
                    uprn: address.uprn || null,
                };
            })
            : [];
    };
    var addressesToTransform = ensureNoUndefinedFields(addresses);
    var options = addressesToTransform.map(function (address) {
        return {
            value: address,
            label: [
                address.addressLine1,
                address.addressLine2,
                address.addressLine3,
                address.postTown,
                address.county,
                address.postcode,
                address.country,
            ]
                .filter(function (x) { return (x ? true : false); })
                .join(', '),
        };
    });
    var form = useForm();
    var _b = useState({
        touched: false,
        error: '',
    }), selectAddressValid = _b[0], setSelectAddressValid = _b[1];
    var getAddressIfValid = function () {
        var selectedAddressField = form.getFieldState('selectedAddress');
        if (selectAddressValid &&
            selectAddressValid.touched &&
            !selectAddressValid.error &&
            selectedAddressField &&
            selectedAddressField.value.value) {
            return selectedAddressField.value.value;
        }
    };
    var clearSelectedAddress = function () {
        var selectedAddressField = form.getFieldState('selectedAddress');
        if (selectedAddressField &&
            selectedAddressField.value &&
            selectedAddressField.value.value) {
            selectedAddressField.value.value = null;
        }
    };
    var updateAddressValidationIfChanged = function (updatedSelectAddressValid) {
        if (selectAddressValid.touched !== updatedSelectAddressValid.touched ||
            selectAddressValid.error !== updatedSelectAddressValid.error) {
            setSelectAddressValid(updatedSelectAddressValid);
        }
    };
    var handleOnClick = function () {
        var validAddress = getAddressIfValid();
        var isValidAddress = false;
        if (validAddress) {
            isValidAddress = true;
            onAddressSelected(validAddress);
            clearSelectedAddress();
        }
        else {
            updateAddressValidationIfChanged({
                touched: true,
                error: selectAddressRequiredMessage,
            });
        }
        if (onValidatePostcode !== null) {
            onValidatePostcode(isValidAddress);
        }
    };
    var handleKeyPress = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleOnClick();
        }
    };
    var dropdownRef = useRef(null);
    useEffect(function () {
        dropdownRef.current && dropdownRef.current.focus();
    }, [loading]);
    var _c = useState(false), addressSelected = _c[0], setAddressSelected = _c[1];
    useEffect(function () {
        setAddressSelected(getAddressIfValid() !== undefined);
    }, [form.getFieldState('selectedAddress')]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Flex, { cfg: { alignItems: 'center' } },
            React.createElement(P, { className: styles.nonEditable + " " + styles.selectedPostcode },
                React.createElement("strong", { id: (testId ? testId + '-' : '') + 'postcode', className: elementStyles.labelText + " " + styles.nonEditableLabel }, postcodeLookupLabel),
                ' ',
                React.createElement("span", { "aria-labelledby": (testId ? testId + '-' : '') + 'postcode' }, formatPostcode(postcode))),
            React.createElement(Button, { onClick: onChangePostcodeClick, testId: (testId ? testId + '-' : '') + 'change-postcode', className: styles.changePostcode, "aria-label": changePostcodeAriaLabel, disabled: loading, appearance: "secondary" }, changePostcodeButton)),
        React.createElement(FFSelect, { ref: dropdownRef, label: selectAddressLabel, name: "selectedAddress", options: options, testId: (testId ? testId + '-' : '') + 'select-address-list', validate: function (value) {
                if (dropdownRef.current && value && value.value) {
                    updateAddressValidationIfChanged({ touched: true, error: '' });
                }
            }, meta: selectAddressValid, notFoundMessage: noAddressesFoundMessage, placeholder: selectAddressPlaceholder, readOnly: true, disabled: loading, initialSelectedItem: addressSelected ? form.getFieldState('selectedAddress') : null, onKeyPress: handleKeyPress }),
        React.createElement(Button, { testId: (testId ? testId + '-' : '') + 'select-address-button', appearance: "secondary", onClick: handleOnClick, className: styles.button + " " + styles.arrowButton, "aria-disabled": !addressSelected },
            React.createElement(Flex, { cfg: {
                    alignItems: 'center',
                    pl: 4,
                    pr: 2,
                } },
                selectAddressButton,
                React.createElement(ArrowRight, { cfg: { fill: 'white' }, width: '32' })))));
};
//# sourceMappingURL=selectAddress.js.map